import './Header.scss'
import { motion } from 'framer-motion'
import React from 'react'
import {images} from '../../constants'
import {AppWrap} from '../../wrapper'
import Time from '../../components/Time/Time'

const scaleVariants = {
  whileInView: {
    scale: [0,1],
    opacity: [0,1],
    transition: {
      duration: 1,
      ease: 'easeInOut'
    }
  }
}

const Header = () => {
  return (
    <header className='app__header app_flex'>
      <motion.div
        whileInView={{x: [-200,0], opacity: [0,1]}}
        transition={{duration: 3}}
        className='app__header-info'
      > 
        <div className='app__header-badge'>
          <div className="badge-cmp app__flex">
            <span>🙏</span>
            <div style={{marginLeft: 10}}>
              <p className="p-text">Hello, I am</p>
              <h1 className="head-text">Ayush Raj</h1>
            </div>
          </div>

          <div className="tag-cmp app__flex">
            <p className="p-text">A Learner</p>
            <p className="p-text">A Tech Explorer</p>
          </div>
        </div>
      </motion.div>

      <motion.div
        whileInView={{opacity: [0,1]}}
        transition={{duration: 0.5, delayChildren: 0.5}}
        className='app__header-img'
      >
        <Time/>
        <motion.img
          whileInView={{scale: [0,1]}}
          transition={{duration: 1, ease: 'easeInOut'}}
          src={images.circle}
          className='overlay_circle'
        >
        </motion.img>
      </motion.div>

      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className='app__header-circles'
      >
        {[images.html, images.javascript, images.react].map(((circle,index) => (
          <div className="circle-cmp app__flex" key={`circle-${index}`}>
            <img src={circle} alt="circle" />
          </div>
        )))}
      </motion.div>
    </header>
  )
}

export default AppWrap(Header,'home')